import { jsx as e } from "react/jsx-runtime";
//#region src/IconDetailPageStartOver.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.23 3.338C12.054.58 18.24 2.223 21.025 7s1.126 10.906-3.696 13.664a10.15 10.15 0 0 1-7.693.985l.49-1.81c2.039.55 4.29.33 6.259-.798 3.92-2.241 5.267-7.223 3.005-11.105-2.264-3.883-7.293-5.218-11.212-2.976a8.1 8.1 0 0 0-3.631 4.358l2.324.617-4.236 3.038L.5 8.242l2.22.59a9.97 9.97 0 0 1 4.51-5.494M16.75 12l-6.875 3.75v-7.5z",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconDetailPageStartOver";
//#endregion
export { t as default };

//# sourceMappingURL=IconDetailPageStartOver.js.map